import Alpine from 'alpinejs'

import barba from "@barba/core";
import scroll from "./animations/scroll/locomotiveScroll";
import lozad from "lozad";

import menu from "./menu";
import search from "./search";
import bidello from "./bidello";
import loader from "./loader";
import policyLinks from "./policyLinks";
import slider from "./slider";
import gallery from "./gallery";

import home from "./routes/home";
import worldMap from "./routes/world-map";
import archiveChampion from "./routes/archive-champion";
import archiveWellness from "./routes/archive-wellness";
import archiveTime from "./routes/archive-time";
import archiveInspire from "./routes/archive-inspire";
import arhiveFaq from "./routes/archive-faq";
import championSingle from "./routes/champion-single";
import wellnessSingle from "./routes/wellness-single";
import timeSingle from "./routes/time-single";
import inspireSingle from "./routes/inspire-single";
import diveIn from "./routes/dive-in";

import { archiveFaqTransition } from "./transitions/archive-faq";
import { archiveInspireTransition } from "./transitions/archive-inspire";
import { archiveChampionTransition } from "./transitions/archive-champion";
import { archiveWellnessTransition } from "./transitions/archive-wellness";
import { archiveTimeTransition } from "./transitions/archive-time";
import { homeTransition } from "./transitions/home";
import { principlesTransition } from "./transitions/principles";
import { singleInspireTransition } from "./transitions/single-inspire";
import { singleChampionTransition } from "./transitions/single-champion";
import { singleWellnessTransition } from "./transitions/single-wellness";
import { singleTimeTransition } from "./transitions/single-time";
import { worldMapTransition } from "./transitions/world-map";
import { defaultTransition } from "./transitions/default";

import explore from "./alpine/explore";
import time from "./alpine/time";
import postcard from "./alpine/postcard";

window.Alpine = Alpine
Alpine.data('explore', explore)
Alpine.data('time', time)
Alpine.data('postcard', postcard)
Alpine.start()

const lozadObserver = lozad('.lozad', {
  rootMargin: '400px 0px',
});
lozadObserver.observe();

const handleResize = () => {
  const vh = window.innerHeight * 0.01;
  document.documentElement.style.setProperty("--vh", `${vh}px`);
};

barba.hooks.beforeEnter(() => {
  lozadObserver.observe();
});

let noCallDiveIn = true

barba.hooks.beforeEnter((data) => {
  console.log(data.next.namespace, " namespace name");
  gallery.init()
  policyLinks()
  if (data.next.namespace === 'dive-in' && !noCallDiveIn) {
    slider.init()
    slider.embedVideo()
    diveIn.init()
  }
});

barba.hooks.once(({ next }) => {
  menu.init();
  search.init();
  bidello.trigger({ name: "enterSite" });
  if (window.location.pathname === '/dive-in/') {
    bidello.on('loaderEnd', () => {
      slider.init()
      slider.embedVideo()
      diveIn.init()
    })
  }
  bidello.on('loaderEnd', () => {
    noCallDiveIn = false
  })
  scroll.update();
});

scroll.init();
new ResizeObserver(() => {
  scroll.update();
}).observe(document.getElementById("content"));

handleResize();
window.addEventListener("resize", handleResize);

barba.init({
  preventRunning: true,
  views: [
    home,
    worldMap,
    arhiveFaq,
    archiveInspire,
    archiveWellness,
    archiveTime,
    archiveChampion,
    wellnessSingle,
    timeSingle,
    inspireSingle,
    championSingle,
  ],

  transitions: [
    archiveFaqTransition,
    archiveInspireTransition,
    archiveWellnessTransition,
    archiveTimeTransition,
    archiveChampionTransition,
    homeTransition,
    principlesTransition,
    defaultTransition,
    singleChampionTransition,
    singleInspireTransition,
    singleWellnessTransition,
    singleTimeTransition,
    worldMapTransition,
  ],
});
